import * as React from 'react';
import { useContext, useEffect } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { ScreenName, StackName } from '../types';
import { HelpdeskScreen, PostFilterScreen } from '../../screens';
import { isMobile } from '../../utils/responsive';
import { StackHeader } from '../../components';
import { NavigationContextStack } from '../../contexts/NavigationContext/NavigationContextStack';

const HelpdeskStack = createStackNavigator();

export default function HelpdeskStackNavigator({ navigation, route }) {
  const { t } = useTranslation();
  const { setChangedStack } = useContext(NavigationContextStack);

  const eventListener = isMobile ? 'focus' : 'blur';

  useEffect(() => {
    return navigation.addListener(eventListener, () => {
      setChangedStack(StackName.HelpdeskStack);
    });
  }, [navigation]);

  return (
    <HelpdeskStack.Navigator
      screenOptions={{
        gestureEnabled: true,
        headerShown: false,
      }}
    >
      <HelpdeskStack.Screen
        name={ScreenName.HelpdeskScreen}
        component={HelpdeskScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return (
                <StackHeader
                  navigation={navigation}
                  headerTitle={t('helpdesk:title')}
                  fromScreen={ScreenName.HelpdeskScreen}
                />
              );
            },
            title: t('helpdesk:title'),
          };
        }}
      />
      <HelpdeskStack.Screen
        name={ScreenName.PostFilterScreen}
        component={PostFilterScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return <StackHeader navigation={navigation} headerTitle={t('common:search')} />;
            },
          };
        }}
      />
    </HelpdeskStack.Navigator>
  );
}
